export const ENDPOINTS = {
    customerProfileView: "/inds/customer-profile-overview",
    subscriptionEmail: "/inds/subscription/change/email",
    changeProfile: "/inds/customer/change-profile/email",
    profileView: "/inds/customer-profile-view",
    peafOptions: "/inds/generate/peafoptions",
    downloadPeafOptions:"/inds/download/peafoptions",
    subscriptionView: "/inds/customer-subscription-view",
    downloadTrackingView:"/inds/customer-download-trackingview",
    primusEliteOptionsMenu:"/inds/primus-elite-options-menu"
};